<template>
  <select
    v-if="garantia.items.length > 1"
    v-model="garantia.selectItem.id"
    @change="selectedItem()"
    class="select"
  >
    <option v-for="item in opcionesOrdenadas" :key="item.id" :value="item.id">
      {{ item.descr }}
    </option>
  </select>
</template>

<script>
import actions from "@/util/actions.js";
import router from "@/router";
export default {
  props: {
    productoId: {
      type: String,
      required: true,
    },
    garantia: {
      type: Object,
      required: true,
    },
  },
  computed: {
    opcionesOrdenadas() {
      return Object.values(this.garantia.items).sort((o1, o2) => {
        if (o1 && o2) {
          if (o1.importeFranquicia && o2.importeFranquicia) {
            return o1.importeFranquicia - o2.importeFranquicia;
          }
          return o1.descr > o2.descr;
        }
        console.log("sorted");
        return o1.id - o2.id;
      });
    },
  },
  methods: {
    selectedItem: async function () {
      const response = await actions.customProducto({
        productoId: this.productoId,
        garantiaId: this.garantia.idGarantia,
        coberturaId: this.garantia.idCobertura,
        selectedId: this.garantia.selectItem.id,
      });
      if (response.data.codigo != 0) {
        let mensajeError = response.data.mensaje;
        if (response.data.codigo === 9999) {
          mensajeError +=
            " .Por favor, ponte en contacto con nosotros para ayudarte.";
        }
        console.log("Redirigimos a pantalla de error");
        router.push({
          name: "ShowErrorPresupuesto",
          params: {
            errorMessage: mensajeError,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.select {
  padding: 0.2em 0.2em;
}
</style>
